/* global preReservationConfiguration */
/* global ReservationConfiguration */

import Vue from "vue"
import loader from "vue-loading-overlay"
import "vue-loading-overlay/dist/vue-loading.css"
import App from "./App.vue"
import PreReservation from "./PreReservation.vue"
import router from "./router"
import store from "./store"
import i18n from "./locale/languages"
import VueGtag from "vue-gtag";

Vue.config.productionTip = false

Vue.filter("toCurrency", function(value) {
  if (typeof value !== "number") {
    return value
  }
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  })
  return formatter.format(value)
})

let googleAnalyticsTrackingId = ''
if (window.preReservationConfiguration) {
  if (window.preReservationConfiguration.googleAnalyticsTrackingId !== "") {
    googleAnalyticsTrackingId = window.preReservationConfiguration.googleAnalyticsTrackingId
  }
}
else if (window.reservationConfiguration) {
  if (window.reservationConfiguration.googleAnalyticsTrackingId !== "") {
    googleAnalyticsTrackingId = window.reservationConfiguration.googleAnalyticsTrackingId
  }
}
Vue.use(VueGtag, {
  config: { 
    id: googleAnalyticsTrackingId,
 }
}, router);

Vue.use(loader)

if (document.querySelector('#app')) {
  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount("#app")
}

if (document.querySelector('#pre-reservation')) {
  new Vue({
    i18n,
    store,
    render: h => h(PreReservation)
  }).$mount("#pre-reservation")
}
